import React from 'react';
import { useUserTheme } from '../../hooks/useUserTheme';

/**
 * Component that applies user theme preferences
 * Must be rendered inside AuthProvider to access user context
 */
export const ThemeApplier: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Apply user theme preferences on mount and when they change
  useUserTheme();

  return <>{children}</>;
};

export default ThemeApplier;